<!--
  Instead of using [ngTemplateOutletContext] on the ng-container and defining the platform specific templates at the base level,
  the templates are defined within the ng-container to maintain scope, thus preserving strong typing.
-->
@if (showHeader()) {
  <ng-content select="select-payment-method-header">
    <h4 class="mb-2">Payment method</h4>
  </ng-content>
}

<ng-content select="select-payment-method-subheader">
  <p *ngIf="cardRestrictionsHint$ | async as cardRestrictionsHint" class="color-gray-100 body-300 mb-2">
    {{ cardRestrictionsHint }}
  </p>
</ng-content>

<div
  *ngIf="(paymentMethodValidationErrorMessage$ | async) as paymentMethodValidationErrorMessage"
  class="alert alert--error mb-4 text-start"
  data-cy="payment-method-validation-error-message"
>
  {{ paymentMethodValidationErrorMessage }}
</div>

<ng-container [ngTemplateOutlet]="paymentPlatformSelectPaymentMethodTemplate$ | async"></ng-container>

<ng-template #stripeSelectPaymentMethodTemplate>
  <app-stripe-select-payment-method
    [intent]="intent$ | async"
    [paymentFlow]="paymentFlow$ | async"
    [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
    [paymentMethodMode]="paymentMethodMode$ | async"
    [setUpLaterEnabled]="setUpLaterEnabled$ | async"
    [emailGateActive]="emailGateActive()"
    [emailGateLocked]="emailGateLocked()"
    [emailGatePrepopulated]="emailGatePrepopulated()"
    (paymentMethodModeChange)="paymentMethodModeChange.emit($event)"
    (paymentMethodSelected)="onPaymentMethodSelected($event)"
    (newPaymentMethodTypeSelected)="openNewPaymentMethodDialog($event)"
    (updateBillingAddress)="openUpdateBillingAddressDialog($event)"
    (lockedNewMethodAttempt)="lockedNewMethodAttempt.emit()"
  ></app-stripe-select-payment-method>
</ng-template>
